import Tables from 'src/class/Tables';
import i18n from '../../../../i18n';

const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: 'name',
      label: i18n.t('common_words.name'),
      minWidth: 150,
      sortable: true,
    },
    {
      prop: 'url',
      label: 'URL',
      minWidth: 150,
      sortable: true,
    },
    {
      prop: 'description',
      label: i18n.t('common_words.description'),
      minWidth: 250,
      sortable: true,
    },
    {
      prop: 'parent_label',
      label: i18n.t('common_words.parent_module2'),
      minWidth: 120,
      sortable: true,
    },
  ];
  const Search = { ...Tables.Search };

  return { Table, Search };
};
export default configTable;
